import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import gym from "../../Assets/Projects/gym.png";
import lacafeteria from "../../Assets/Projects/lacafeteria.png";
import mapa from "../../Assets/Projects/mapa.png";
import apple from "../../Assets/apple.png";
import training from "../../Assets/port.png";
import juanitaf from "../../Assets/juanitaf.png";
import jenovac from "../../Assets/jenovac.png";
import minua from "../../Assets/minua.png";
import alairelibre from "../../Assets/alairelibre.png";
import distribuidora from "../../Assets/distribuidora.png";
import septiembredulce from "../../Assets/sep.png";
import venezia from "../../Assets/venezia.png";
import realzando from "../../Assets/realzando.png";
import celutec from "../../Assets/celutec.png";
import bela from "../../Assets/bela.png";
import manobendita from "../../Assets/manobendita.png";
import pasotoros from "../../Assets/pasotoros.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mis <strong className="purple">Trabajos </strong>
        </h1>
        <p style={{ color: "white" }}>Redes sociales y webs de mis ultimos clientes!</p>
        <Row className="d-flex justify-content-center">

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bela}
              isBlog={false}
              title="Bela naturaleza"
              description="Web con diseño moderno y colores suaves, con compras dentro de la web con mercado pago y agenda para cada cita de masajes, en administración se puede ver todas las citas además de modificar a gusto los horarios y terapeutas disponibles"
              ghLink="https://www.instagram.com/belanaturezacl/"
              demoLink="https://www.belanatureza.cl"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={manobendita}
              isBlog={false}
              title="Mano Bendita"
              description="Tienda de Productos para tatuadores en Ecuador, pagos implementando Payphone y Paypal, diseño personalizado a gusto del cliente, sistema de administración para manejar la subida de productos y sus precios. proyecto realizado con React.js y Express.js, hosting en Vercel con dominio de Don web."
              ghLink="https://www.instagram.com/manobenditaec/"
              demoLink="http://manobendita.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pasotoros}
              isBlog={false}
              title="Paso de los Toros"
              description="Ferreteria de Uruguay con todos sus productos subidos, diseño llamativo apegado al logo de la empresa, divido de distintas secciones para dejar todo estructurado, proyecto hecho con React.js y Express.js con Hosting en Vercel"
              ghLink="https://www.instagram.com/electropasodelostoros/"
              demoLink="https://ferreteriaelectropasodelostoros.vercel.app/"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={celutec}
              isBlog={false}
              title="Celutec Reparaciones"
              description="(privada) Web administrativa para empresa de reparación de dispositivos con posibilidad de agregar nuevos pedidos, editarlos luego de subido, con firma online para cada pedido y registro de todos los pedidos hechos en la web"
              ghLink="https://www.instagram.com/celutecreparaciones/"
              demoLink="https://celutecreparaciones.vercel.app/"
            />
          </Col>
  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={venezia}
              isBlog={false}
              title="Venezia Store"
              description="Web online para la venta de todo tipo de indumentaria, desde caravanas, pulseras, anillos hasta bikinis, ponchos, chalecos y más! Los pagos se hacen con Mercado pago y se procesan en la web, teniendo una sección de administración para ver las compras!"
              ghLink="https://www.instagram.com/veneziaaccesorios17/"
              demoLink="https://veneziastore.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={realzando}
              isBlog={false}
              title="Realzando Miradas"
              description="Agenda online para la famosa Andrea Viloria, se agendan dentro de la web y las citas quedan guardadas en la base de datos, en la sección de administración se puede marcas esas citas como pagadas o eliminarlas si el cliente no hizo el pago."              
              ghLink="https://www.instagram.com/andrea_browspmu/"
              demoLink="https://realzandomiradas.vercel.app/"
            />
          </Col>
  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={septiembredulce}
              isBlog={false}
              title="Septiembre Dulce"
              description="Plataforma web para la pastelería Septiembre Dulce que ofrece pedidos personalizados, desarrollada con React y Node. Permite seleccionar el tipo de pastel, fecha de entrega y cantidad, gestionando cada pedido mediante un carrito de compras y notificaciones automáticas. Incluye una galería de productos con categorías filtrables, sección de contacto y panel administrativo para controlar pedidos, actualizar precios y subir nuevas imágenes. Su diseño en tonos cálidos transmite dulzura y cercanía, asegurando una experiencia agradable tanto para clientes como administradores."              
              ghLink="https://www.instagram.com/septiembre_dulce_/"
              demoLink="https://septiembredulce.vercel.app/"
            />
          </Col>
  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={distribuidora}
              isBlog={false}
              title="Distribuidora Bellisima"
              description="Plataforma online para la distribución de productos de belleza, construida en React y Node. Integra más de 20 marcas con filtros por tipo de producto, carrito de compras y pagos seguros con Mercado Pago. Incluye testimonios de clientes, galería del equipo y un formulario interno para que los administradores añadan productos directamente a la base de datos en Airtable. Su diseño minimalista en blanco y negro con detalles en azul refuerza la imagen profesional de la marca, complementado con un sidebar y un acceso rápido vía WhatsApp flotante."
              ghLink="https://www.instagram.com/distribuidora_bellisima/"
              demoLink="https://distribuidorabellisima.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={alairelibre}
              isBlog={false}
              title="Al Aire Libre"
              description="Sitio web diseñado para los amantes de la pesca y la exploración, desarrollado con React y Node. La plataforma permite adquirir productos especializados mediante Mercado Pago, con un carrito integrado y gestión de datos en Airtable. Además, ofrece videos exclusivos, la opción de inscribirse en excursiones en distintas localidades y redes sociales flotantes para mayor interacción. Su diseño colorido transmite dinamismo y conecta con la esencia de la aventura al aire libre."
              ghLink="https://www.instagram.com/alairelibreuy"
              demoLink="https://alairelibre.vercel.app/"
            />
          </Col>
  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jenovac}
              isBlog={false}
              title="Jenovac"
              description="Tienda virtual enfocada en moda, desarrollada con React y Node. Con Airtable como base de datos, organiza productos en múltiples categorías con la posibilidad de filtrar por tallas, precios y colores. Incorpora buscador, carrito de compras y procesamiento de pagos mediante Mercado Pago, enviando confirmaciones por correo electrónico. El diseño minimalista en blanco y negro transmite sobriedad y estilo, destacando la identidad visual de la marca."
              ghLink="https://www.instagram.com/jenovac_indumentaria/"
              demoLink="https://jenovac.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={minua}
              isBlog={false}
              title="Minua"
              description="Plataforma online especializada en la venta y alquiler de vestidos, construida en React y Node. Utiliza Airtable para la gestión de productos y categorías, integrando filtros avanzados por precio, tallas y colores. Incluye buscador, carrito de compras y sistema de pago con Mercado Pago, con notificaciones automáticas vía email tras cada transacción. Su diseño en colores suaves refuerza la estética elegante de la marca y asegura una navegación clara para el usuario."
              ghLink="https://www.instagram.com/minua_indumentaria/"
              demoLink="https://minua.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={juanitaf}
              isBlog={false}
              title="JuanitaF"
              description="E-commerce de prendas desarrollado en React y Node con Airtable como base de datos para gestionar productos, categorías y precios. La tienda integra buscador por categoría, filtros dinámicos y carrito de compras, con pagos seguros a través de Mercado Pago. Cada compra genera un correo automático al administrador con los datos de la compra. El diseño se apoya en tonos pastel para transmitir frescura y cercanía, ofreciendo una experiencia intuitiva en todo tipo de dispositivos."
              ghLink="https://www.instagram.com/juanitafcueros/"
              demoLink="https://juanitaf.vercel.app/"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={training}
              isBlog={false}
              title="360 Training"
              description="Plataforma desarrollada en React y Node que permite a los usuarios registrarse, contratar planes mensuales o por clase y acceder a entrenamientos de box y gimnasio. Integra un sistema de pago con la API de Mercado Pago y Airtable como base de datos para gestionar planes y reservas. Incluye mapa interactivo con la ubicación de las sedes, clases virtuales con inscripción online y la posibilidad de enviar consultas directamente desde la web."
              ghLink="https://www.instagram.com/360training_/"
              demoLink="https://360training.vercel.app/"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={apple}
              isBlog={false}
              title="Apple Blue"
              description="Tienda online de celulares y accesorios para iPhone, construida con React y Express. El sistema organiza los productos en categorías, cuenta con buscador integrado, carrito de compras y procesamiento de pagos mediante Mercado Pago. Cada pedido se envía automáticamente al correo de la tienda con la información del cliente. Incluye mapa del local y una interfaz de diseño amigable en tonos celestes que refuerza la identidad de la marca."
              ghLink="https://www.instagram.com/applebluesant.lucia/"
              demoLink="https://appleblue.vercel.app/"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gym}
              isBlog={false}
              title="Cronos Gym"
              description="Proyecto desarrollado en React y Node, con integración de Airtable como base de datos. La plataforma muestra los diferentes planes de entrenamiento disponibles en los tres locales del gimnasio, permitiendo contratarlos online mediante la API de Mercado Pago. Los clientes con suscripción acceden a una sección exclusiva con rutinas personalizadas, guías de ejercicios y videos explicativos."
              ghLink="https://www.instagram.com/gym_cronostraining?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              demoLink="https://cronosgym.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lacafeteria}
              isBlog={false}
              title="La Cafeteria Restaurante"
              description="Aplicación web realizada en React con un diseño cálido y atractivo, enfocada en mostrar la identidad del restaurante. Incluye galería de imágenes del local y su equipo, el menú actualizado, ubicación en mapa interactivo y un formulario de contacto directo vía correo electrónico. Su estética utiliza colores claros y llamativos para transmitir cercanía y resaltar la experiencia gastronómica."
              ghLink="https://www.instagram.com/lacafeteria.uy?igsh=dWJ5ZDdxN2FzYnd6"
              demoLink="https://lacafeteriauy.vercel.app/"
            />
          </Col>
                
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mapa}
              isBlog={false}
              title="Mapa Google Maps"
              description="Desarrollado con JavaScript y Node, este sistema integra Google Maps API con una base de datos en MySQL para gestionar todos los marcadores. Permite a los usuarios trazar rutas entre ciudades, seleccionar puntos de interés, identificar zonas de riesgo y acceder a descripciones detalladas de cada parador. También ofrece funciones como captura de la ruta trazada, estilos personalizados del mapa y vistas en 3D para una experiencia más completa."
              ghLink="https://drive.google.com/drive/folders/1yZCO9b9brVlUpT-wvOjD0sWRN0JHUBrf"
              demoLink="https://drive.google.com/drive/folders/1yZCO9b9brVlUpT-wvOjD0sWRN0JHUBrf"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
